import { createQuery } from 'QueryKit'
import { summaryData } from 'API/definitions/iris/report-summary'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useSummaryDataQuery = createQuery<any, any, any>({
  primaryKey: 'summary-report_data',
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  queryFn: ({ queryKey: [primaryKey, variables] }) => {
    return summaryData(variables?.filterQueryParams)
  },
  message: 'Failed to get images',
})

export { useSummaryDataQuery }
